var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
class Label extends Component {
  render() {
    const {
      label,
      orient,
      width,
      offset,
      height
    } = this.props;
    const horizontalTransform = "rotate(270)";
    const verticalTransform = "rotate(0)";
    const textAnchor = "middle";
    const strokeWidth = "0.01";
    if (label) {
      switch (orient) {
        case "top":
        case "bottom":
          return /* @__PURE__ */ jsx("text", { strokeWidth, textAnchor, transform: verticalTransform, x: width / 2, y: offset, children: label });
        case "left":
          return /* @__PURE__ */ jsx("text", { strokeWidth, textAnchor, transform: horizontalTransform, y: -offset, x: -height / 2, children: label });
        case "right":
          return /* @__PURE__ */ jsx("text", { strokeWidth, textAnchor, transform: horizontalTransform, y: offset, x: -height / 2, children: label });
      }
    }
    return /* @__PURE__ */ jsx("text", {});
  }
}
__publicField(Label, "propTypes", {
  height: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  horizontalTransform: PropTypes.string,
  label: PropTypes.string.isRequired,
  width: PropTypes.number,
  orient: PropTypes.string,
  // Just to satisfy eslint
  // eslint-disable-next-line zillow/react/forbid-prop-types
  offset: PropTypes.any
});
export {
  Label as default
};
